import { ADMIN_API_BASE } from '../../callApi'
import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

export const collection = 'systemAdministratorPromotion'

export const schema = new schemas.Entity(collection)

export type SystemAdministratorPromotionDecision = {
  promotionId: string
  accept: boolean
}

export const create = (callApi: CallApi) => (_: unknown, body: object) =>
  callApi(`${ADMIN_API_BASE}/system-admins/promotions`, schema, {
    method: 'POST',
    body,
  })

export const update =
  (callApi: CallApi) =>
  (_: unknown, body: SystemAdministratorPromotionDecision) =>
    callApi(
      `${ADMIN_API_BASE}/system-admins/promotions/${body.promotionId}`,
      schema,
      {
        method: 'PUT',
        body,
      }
    )
